const ControlManager={}
let options={}

const REQUIRED_CLASS='span.required'
const REQUIRED_ELEMENT='<span class="required">*</span> '
const HIDDEN_CLASS='hidden'

const setLabel=(tag_label,visible,required)=>{
    if(tag_label){

        let labelId = tag_label.startsWith('#') ? tag_label.slice(1) : tag_label;

        const isValidId = /^[a-zA-Z0-9_-]+$/.test(labelId);
        if (!isValidId) return;

        const element = document.getElementById(labelId);
        if (!element) return;

        let label_element=window.$(element)
    
        if(label_element){
            label_element.find(REQUIRED_CLASS).remove()
    
            if(required){
                label_element.prepend(REQUIRED_ELEMENT)   
            } 
    
            label_element.removeClass(HIDDEN_CLASS)
            
            if(!visible){
                label_element.addClass(HIDDEN_CLASS)    
            }
        }
    }
}

const setSubLabel=(tag_sub_label,visible)=>{
    if(tag_sub_label){

        let labelId = tag_sub_label.startsWith('#') ? tag_sub_label.slice(1) : tag_sub_label;

        const isValidId = /^[a-zA-Z0-9_-]+$/.test(labelId);
        if (!isValidId) return;

        const element = document.getElementById(labelId);
        if (!element) return;

        let label_sub_element= window.$(element)
        
        if(label_sub_element){
            label_sub_element.removeClass(HIDDEN_CLASS)
            
            if(!visible){
                label_sub_element.addClass(HIDDEN_CLASS)    
            }
        }    
    }
}

//Set of options
options.requiredClass=REQUIRED_CLASS
options.requiredElement=REQUIRED_ELEMENT
options.hiddenClass=HIDDEN_CLASS

//Set of functions
ControlManager.setLabel=setLabel
ControlManager.setSubLabel=setSubLabel

ControlManager.options=options

export default ControlManager